import '../css/index.css'

import Alpine from 'alpinejs'
import 'altcha'
import 'altcha/i18n/de'

import './hero-animation.js'
import './components/testimonial-card.js'

window.Alpine = Alpine
Alpine.start()
